import { useEffect, useRef } from 'react';
import { NOTIFYCANCEL_ICON } from '../../../utills/image-constant';
import Loader from '../../components/common/Loader';

const AdminNotification = ({ pandding, notification, changeAllSeenStauts, setNotificationOpen }) => {
    const notificationRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setNotificationOpen(false);  // Close notification when clicking outside
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setNotificationOpen]);

    return (
        <div>
            <div ref={notificationRef} className='Notification_div'>
                {notification ? (
                    <div className='Notification_div_content'>
                        {pandding ? (
                            <Loader />
                        ) : (
                            notification.map((val, i) => (
                                <div
                                    key={i}
                                    className={`notify-div cursor-pointer p-3 ${val?.seenStatus === 0 ? "notify-unseen" : "notify-seen"}`}
                                >
                                    <div className='row'>
                                        <div className='col-11' onClick={() => changeAllSeenStauts(val?.id, 1)}>
                                            <p className='notify-text'>{val?.msg}</p>
                                            <p className='notify-date mt-2'>
                                                Date - <span className='notify-text'>{val?.createdDate}</span>
                                            </p>
                                        </div>
                                        <div className='col-1 d-flex justify-content-center'>
                                            <img
                                                className='notify-cancel-icon'
                                                src={NOTIFYCANCEL_ICON}
                                                alt="close"
                                                onClick={() => changeAllSeenStauts(val?.id, 2)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                ) : (
                    <div className='d-flex justify-content-center align-items-center mt-5'>
                        <p className='notify-text'>There is no Notification !!</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminNotification;
